document.addEventListener('DOMContentLoaded', function () {
  var overlay = document.querySelector('.product-popup-overlay');
  if (!overlay) return;

  var delay = parseInt(overlay.dataset.showDelay, 10) || 0;
  var frequency = overlay.dataset.frequency;
  var storageKey = 'product_popup_last_shown_' + overlay.id;

  function shouldShow() {
    if (frequency === 'every_page_load') return true;

    var last = localStorage.getItem(storageKey);
    if (!last) return true;

    var now = Date.now();
    var elapsed = now - parseInt(last, 10);

    if (frequency === 'once_per_session') {
      return !sessionStorage.getItem(storageKey);
    }

    if (frequency === 'once_per_day') {
      return elapsed > 24 * 60 * 60 * 1000;
    }

    return true;
  }

  function markShown() {
    localStorage.setItem(storageKey, Date.now().toString());
    sessionStorage.setItem(storageKey, '1');
  }

  function openPopup() {
    overlay.style.display = 'flex';
    markShown();
  }

  function closePopup() {
    overlay.style.display = 'none';
  }

  if (shouldShow()) {
    setTimeout(openPopup, delay * 1000);
  }

  overlay.querySelector('.product-popup-close').addEventListener('click', closePopup);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closePopup();
  });

  var form = overlay.querySelector('[data-popup-add-form]');
  var messageEl = overlay.querySelector('[data-popup-message]');

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var button = form.querySelector('.product-popup-add-btn');
    var variantId = form.querySelector('input[name="id"]').value;

    button.disabled = true;
    messageEl.textContent = '';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error(err.description || 'Could not add to cart');
          });
        }
        return res.json();
      })
      .then(function () {
        messageEl.style.color = 'green';
        messageEl.textContent = 'Added to cart!';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(closePopup, 1200);
      })
      .catch(function (err) {
        messageEl.style.color = 'red';
        messageEl.textContent = err.message;
      })
      .finally(function () {
        button.disabled = false;
      });
  });
});